import {HTTP} from "@/http";

class LdapAccountProviderServiceClass {
  basePath = 'api/v2/remote-account-providers/ldap';

  /**
   * Get all LDAP account providers for a customer
   * @param {string} customerId
   * @returns {Promise<Object>}
   */
  getByCustomer(customerId) {
    return HTTP.get(this.basePath, {params: {customerId}});
  }

  /**
   * Create a new LDAP account provider
   * @param {Object} provider { customerId, serverId, distinguishedName, role }
   * @returns {Promise<Object>}
   */
  create(provider) {
    return HTTP.post(this.basePath, provider);
  }

  /**
   * Update an existing LDAP account provider
   * @param {Object} provider Provider object including its id
   * @returns {Promise<Object>}
   */
  patch(provider) {
    return HTTP.patch(`${this.basePath}/${provider.id}`, provider);
  }

  /**
   * Validate an LDAP account provider connection without persisting it.
   * @param {Object} provider
   * @returns {Promise<Object>}
   *          ({ valid, matchedAccountsCount, message, error })
   */
  validate(provider) {
    if (provider.id) {
      return HTTP.post(`${this.basePath}/${provider.id}/validate`, {
        serverId: provider.serverId,
        distinguishedName: provider.distinguishedName,
        role: provider.role,
      });
    }
    return HTTP.post(`${this.basePath}/validate`, {
      customerId: provider.customerId,
      serverId: provider.serverId,
      distinguishedName: provider.distinguishedName,
      role: provider.role,
    });
  }

  /**
   * Delete an LDAP account provider
   * @param {string} id
   * @returns {Promise<Object>}
   */
  delete(id) {
    return HTTP.delete(`${this.basePath}/${id}`);
  }
}

/**
 * @type {LdapAccountProviderServiceClass}
 */
export const ldapAccountProviderService = new LdapAccountProviderServiceClass();
